export default __webpack_public_path__ + "static/media/jorio.de143f32.png";